import protobuf from 'protobufjs';
import messages from '@/protobuf/index';

// This is your plugin object. It can be exported to be used anywhere.
const module = {

  transform: function (response) {
    // const buffer = protobuf.util.newBuffer(protobuf.util.base64.length(response.data));
    // protobuf.util.base64.decode(response.data, buffer, 0);

    if (response.data !== null) {
      const buffer = Buffer.from(response.data, 'binary');

      const msg = messages.at.hotelmeister.protobuf.backend.ResponseEnvelope.decode(buffer).toJSON();

      if (msg.data !== null && typeof msg.data !== 'undefined') {
        msg.data = msg.data.map(it => messages.at.hotelmeister.protobuf.backend[msg.type].decode(Buffer.from(it, 'base64')).toJSON());
      } else {
        msg.data = [];
      }

      if (msg.single === true) {
        msg.data = msg.data.length > 0 ? msg.data[0] : null;
      }

      response.data = msg;
    }

    return response;
  },
};

export default module;



// WEBPACK FOOTER //
// ./src/plugins/proto/index.js